import React, { useCallback, useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import Button from "../../widgets/button";
import Tabs from "../../widgets/tabs";
import LoaderTrans from "../../widgets/loadertrans";
import Table from "../../widgets/table";
import Map from "../../img/map-pin.svg";
import ErrorCard from "../../widgets/error";
import {
  ERROR_MESSAGE,
  NODATA_ERROR_MESSAGE,
} from "../../constants/dialog.constants";
import {
  BENCHMARK_SCHEDULING,
  BENCHMARK_SCHEDULINGCOMPLETED,
  dateFormat,
  DATE_FORMAT_UPDATED
} from "../../constants/app.constants";
import {
  fetchBenchmarkScheduledJobs,
  fetchBenchmarkCompletedJobs,
} from "../scheduling/scheduling.utils";
import { headerType } from "../../widgets/table";
import SchedulingApprovalModal from "./schedulingApprovalModal";
import SchedulingRequestChangeModal from "./schedulingRequestChangeModal";
import SchedulingMapChangeModal from "./schedulingMapModal";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { faL } from "@fortawesome/free-solid-svg-icons";

const tabData = [
  { label: "Overview", path: "Overview"},
  { label: "Client Connection", path: "ClientConnection"},
  { label: "Invoicing", path:"Invoicing"},
  { label: "Scheduling", path:"Scheduling"},
  { label: "Quotes", path: "Quotes"},
];

export interface ButtonProps {
  btnClassName: string;
  btnName: string;
  btnType?: string;
  btnSrc?: string;
  btnColHeading?: string;
}

const colHeadersWithEstYard: headerType[] = [
  { label: "ID" },
  { label: "Scheduled Date" },
  { label: "Property" },
  { label: "Estimated Yards" },
  //{ label: "NTE Yards" },
  { label: "Product/Color" },
  { label: "% Complete",
      style: { alignment: { textAlign: "center", verticalAlign: "middle",  } }

  },
  {label: "Amount",
     style: { alignment: { textAlign: "right", verticalAlign: "middle",  } } 

  } 
];


const colHeadersWithoutEstYard: headerType[] = [
  { label: "ID" },
  { label: "Scheduled Date" },
  { label: "Property" },
 // { label: "NTE Yards" },
  { label: "Product/Color" },
  { label: "% Complete",
     style: { alignment: { textAlign: "center", verticalAlign: "middle",  } }
  },
  {label: "Amount",
      style: { alignment: { textAlign: "right", verticalAlign: "middle",  } } 

  }
];



const colHeadersCompletedWithEstYards: headerType[] = [
  { label: "Completed Date", exlStyle: { width: 15 } },
  { label: "Property", exlStyle: { width: 30 } },
  { label: "Estimated Yards", exlStyle: { width: 12 } },
  { label: "Invoice #", exlStyle: { width: 12 } },
  { label: "Invoice Date", exlStyle: { width: 12 } },
  { label: "Product/Color", exlStyle: { width: 20 } },
  { label: "Amount", style: { alignment: { textAlign: "right", verticalAlign: "middle",  } }  },
];

//  style: { alignment: { textAlign: "right", verticalAlign: "middle",  } }

const colHeadersCompletedWithoutEstYards: headerType[] = [
  { label: "Completed Date", exlStyle: { width: 15 } },
  { label: "Property", exlStyle: { width: 30 } },
  { label: "Invoice #", exlStyle: { width: 12 } },
  { label: "Invoice Date", exlStyle: { width: 12 } },
  { label: "Product/Color", exlStyle: { width: 20 } },
  { label: "Amount", style: { alignment: { textAlign: "right", verticalAlign: "middle",  } }  },
  
];



const Scheduling: React.FC = () => {
  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const [endDate, setEndDate] = useState<Dayjs | null>(null);
  const [isModalApproveOpen, setIsModalApproveOpen] = useState(false);
  const [isModalRequestOpen, setIsModalRequestOpen] = useState(false);
  const [isModalMapOpen, setIsModalMapOpen] = useState(false);
  const [approveId, setApproveId] = useState(0);
  const [requestChangeId, setRequestChangeId] = useState(0);
  const [mapId, setMapId] = useState(0);
  const [dateError, setDateError] = useState<string>("");
  const [isMapTrue, setIsMapTrue] = useState(false);
  const [isRequestChangeTrue, setIsRequestChangeTrue] = useState(false);
  const [isApproveTrue, setIsApproveTrue] = useState(false);

  
const [dateKey, setDateKey] = useState(0);

  const {
    isLoading: isLoadingBenchmarkScheduledJobs,
    error: errorBenchmarkScheduledJobs,
    data: dataBenchmarkScheduledJobs,
    isFetching: isFetchingBenchmarkScheduledJobs,
    refetch: refetchScheduledJobs,
  } = useQuery({
    queryKey: [BENCHMARK_SCHEDULING],
    queryFn: () => fetchBenchmarkScheduledJobs(localStorage.getItem("ID") ?? ""),
    refetchOnWindowFocus: false,
  });

  const hideEstimated = dataBenchmarkScheduledJobs?.hideEstimated ?? false;



  const colHeaders = hideEstimated
  ? colHeadersWithoutEstYard
  : colHeadersWithEstYard;




  // const {
  //   isLoading: isLoadingBenchmarkCompletedJobs,
  //   error: errorBenchmarkCompletedJobs,
  //   data: dataBenchmarkCompletedJobs,
  //   isFetching: isFetchingBenchmarkCompletedJobs,
  //   refetch,
  // } = useQuery({
  //   queryKey: [BENCHMARK_SCHEDULINGCOMPLETED],
  //   queryFn: () => fetchBenchmarkCompletedJobs(
  //     localStorage.getItem("ID") ?? "",
  //     startDate?.toDate(),
  //     endDate?.toDate()
  //   ),
  //   refetchOnWindowFocus: false,
  // });

  const {
  isLoading: isLoadingBenchmarkCompletedJobs,
  error: errorBenchmarkCompletedJobs,
  data: dataBenchmarkCompletedJobs,
  isFetching: isFetchingBenchmarkCompletedJobs,
  refetch,
} = useQuery({
  queryKey: [BENCHMARK_SCHEDULINGCOMPLETED, startDate, endDate], // optional: keep updated key
  queryFn: () =>
    fetchBenchmarkCompletedJobs(
      localStorage.getItem("ID") ?? "",
      startDate?.toDate(),
      endDate?.toDate()
    ),
  enabled: false, 
  refetchOnWindowFocus: false,
});

  const hideEstimated_completed = dataBenchmarkCompletedJobs?.hideEstimated ?? false;

  
   const colHeadersCompleted = hideEstimated_completed
  ? colHeadersCompletedWithoutEstYards
  : colHeadersCompletedWithEstYards;




  useEffect(() => {
  if (startDate && endDate) {
    if (startDate.isAfter(endDate)) {
      setDateError("Start date cannot be greater than end date.");
    } else {
      setDateError("");
      refetch(); // ✅ Trigger API call when dates are valid
    }
  } else {
    setDateError(""); // Clear if one of the dates is missing
  }
}, [startDate, endDate, refetch]);



const onChangeFieldValues = useCallback(
  (id: string, updatedValue: Dayjs | null) => {
    if (id === "startDate") {
      setStartDate(updatedValue);
    } else if (id === "endDate") {
      setEndDate(updatedValue);
    }
  },
  []
);



  // const onChangeFieldValues = useCallback(
  //   (id: string, updatedValue: Dayjs | null) => {
  //     if (id === "startDate") {
  //       setStartDate(updatedValue);
  //       if (endDate && updatedValue && updatedValue.isAfter(endDate)) {
  //         setDateError("Start date cannot be after end date.");
  //       } else {
  //         setDateError("");
  //       }
  //     } else if (id === "endDate") {
  //       setEndDate(updatedValue);
  //       if (startDate && updatedValue && updatedValue.isBefore(startDate)) {
  //         setDateError("End date cannot be before start date.");
  //       } else {
  //         setDateError("");
  //       }
  //     }
  //   },
  //   [startDate, endDate]
  // );

  const onResetButton = useCallback(() => {
    setStartDate(null);
    setEndDate(null);
      // force both datepickers to remount → clears ANY invalid text
    setDateKey(prev => prev + 1);
    setDateError("");
    refetch();
  }, []);

  useEffect(() => {
    const isValidRange =
      !startDate || !endDate || (startDate && endDate && startDate.isBefore(endDate) || startDate.isSame(endDate));
    if (isValidRange) {
      refetch();
      refetchScheduledJobs();
    }
  }, [startDate, endDate, isApproveTrue, isMapTrue, isRequestChangeTrue]);

  const onClickApprovalScheduling = useCallback((id: number) => {
    setIsModalApproveOpen(true);
    setApproveId(id);
  }, []);

  const onClickRequestChangeScheduling = useCallback((id: number) => {
    setIsModalRequestOpen(true);
    setRequestChangeId(id);
  }, []);

  const onClickMapScheduling = useCallback((id: number) => {
    setIsModalMapOpen(true);
    setMapId(id);
  }, [mapId]);

  const handleModalClose = useCallback(() => {
    setIsModalApproveOpen(false);
    setIsModalRequestOpen(false);
    setIsModalMapOpen(false);
  }, []);

 
  const handleSubmit = useCallback(() => {
    setIsMapTrue(true);
    setIsRequestChangeTrue(true);
    setIsApproveTrue(true);
    setIsModalMapOpen(false);
    setIsModalRequestOpen(false);
    setIsModalApproveOpen(false);
  },[]);

  // const buttonsClass: ButtonProps[] = [
   
  //   {
  //     btnClassName: "imgIcon  m-1",
  //     btnName: "Map",
  //     btnType: "Image",
  //     btnSrc: Map,
  //     btnColHeading: "Map",
  //   },
  //   {
  //     btnClassName: "btn btn-sm cancelPwdBtn  m-1",
  //     btnName: "Request Change",
  //     btnType: "Button",
  //     btnColHeading: "",
  //   },
  // ];

  

  const buttonsClass: ButtonProps[] = [
  // 0 → Dummy Approve (invisible but keeps indexes correct)
  {
    btnClassName: "d-none",     // hides it
    btnName: "",
    btnType: "Button",
    btnColHeading: "",
  },

  // 1 → Map button
  {
    btnClassName: "imgIcon m-1",
    btnName: "Map",
    btnType: "Image",
    btnSrc: Map,
    btnColHeading: "Map",
  },

  // 2 → Request Change button
  {
    btnClassName: "btn btn-sm cancelPwdBtn m-1",
    btnName: "Request Change",
    btnType: "Button",
    btnColHeading: "",
  },
];



return (
  <div className="container-fluid">
    <div className="body-content">
      <Tabs tabs={tabData} activeTabIndex={3} />

      {/* Scheduled Jobs Section */}
      <div className="d-flex flex-column propertiesContent">
        {(isLoadingBenchmarkScheduledJobs || isFetchingBenchmarkScheduledJobs) && (
          <LoaderTrans msg="Loading Scheduled Jobs" />
        )}

        {/* Show only one error message for Scheduled Jobs */}
        {!isLoadingBenchmarkScheduledJobs &&
          (errorBenchmarkScheduledJobs || !dataBenchmarkScheduledJobs) && (
            <ErrorCard
              msg={errorBenchmarkScheduledJobs ? ERROR_MESSAGE : NODATA_ERROR_MESSAGE}
            />
          )}

        {dataBenchmarkScheduledJobs && (
          <div className="tblTitle">
            Scheduled Jobs
            <Table
              id="scheduledJobs"
              classNameTable="tblHeightScheduled"
              headers={colHeaders}
              data={dataBenchmarkScheduledJobs?.rows ?? []}
              buttonsClass={buttonsClass}
              // onClickButton1={onClickApprovalScheduling}
              onClickButton2={onClickMapScheduling}
              onClickButton3={onClickRequestChangeScheduling}
            />
          </div>
        )}
      </div>

      {/* Completed Jobs Section */}
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <div className="d-flex flex-column propertiesContent">
          <div>
            <div className="tblTitle">Completed Jobs</div>
            <div className="date-filter-container">
                 <DatePicker
              key={dateKey + "-start"}
              label="Start Date"
              value={startDate}
              onChange={(newValue) => {
                setStartDate(newValue);
              }}
              format={DATE_FORMAT_UPDATED}
              disableFuture
              slotProps={{
                textField: {
                  size: "small",
                  className: "date-input-field"
                }
              }}
            />
              <DatePicker
                key={dateKey + "-end"}
                label="End Date"
                value={endDate}
                onChange={(newValue) => {
                  setEndDate(newValue);
                }}
                format={DATE_FORMAT_UPDATED}
                disableFuture
                slotProps={{
                  textField: {
                    size: "small",
                    className: "date-input-field"
                  }
                }}
              />
              <button className="btn btn-sm resetBtn" onClick={onResetButton}>
                Reset
              </button>
            </div>
            {dateError && <p className="text-danger">{dateError}</p>}
          </div>

          {(isLoadingBenchmarkCompletedJobs || isFetchingBenchmarkCompletedJobs) && (
            <LoaderTrans msg="Loading Completed Jobs" />
          )}

          {/* Show only one error message for Completed Jobs */}
          {!isLoadingBenchmarkCompletedJobs &&
            !isFetchingBenchmarkCompletedJobs &&
            (errorBenchmarkCompletedJobs ||
              dataBenchmarkCompletedJobs?.rows?.length === 0) && (
              <ErrorCard
                msg={
                  errorBenchmarkCompletedJobs ? ERROR_MESSAGE : NODATA_ERROR_MESSAGE
                }
              />
            )}

          {dataBenchmarkCompletedJobs?.rows?.length > 0 && (
            <Table
              id="completedJobs"
              classNameTable="tblHeight"
              headers={colHeadersCompleted}
              data={dataBenchmarkCompletedJobs?.rows ?? []}
              exportExcel
              fileName="Completed Jobs"
            />
          )}
        </div>
      </LocalizationProvider>

      {/* Modals */}
      <SchedulingApprovalModal
        isOpen={isModalApproveOpen}
        onClose={handleModalClose}
        onSubmit={handleSubmit}
        approveId={approveId}
      />
      <SchedulingRequestChangeModal
        isOpen={isModalRequestOpen}
        onClose={handleModalClose}
        onSubmit={handleSubmit}
        requestChangeId={requestChangeId}
      />
      <SchedulingMapChangeModal
        isOpen={isModalMapOpen}
        onClose={handleModalClose}
        onSubmit={handleSubmit}
        mapId={mapId}
      />
    </div>
  </div>
);

};

export default Scheduling;
